import React, {useEffect} from 'react';
import CategoryList from './categoryList/CategoryList';
import {CategoryTable} from './categoryTable/CategoryTable';
import {StaticCategoryTable} from './categoryTable/StaticCategoryTable';
import {HeaderBanner} from './headerBanner/HeaderBanner';
import Prolog from './prolog/Prolog';
import {Helmet} from 'react-helmet-async';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';

import {closeCategoriesMenu} from '../../utility/DialogHelper';

export const CategoryOverview = (props: {
    description: string;
    image: any;
    static: boolean;
    staticDetails: string;
    sheeTitle: string;
    metaDescription: any;
    keywords: any;
}) => {
    const {t, i18n} = useTranslation();
    const location = useLocation();
    useEffect(() => {
        closeCategoriesMenu();
        window.scrollTo(0, 0);
        // Change language based on the current pathname
        const path = location.pathname; // Get the current pathname
        if (path.startsWith('/de') || path === '/de') {
            i18n.changeLanguage('de');
        } else if (path.startsWith('/en') || path === '/en') {
            i18n.changeLanguage('en');
        }
    }, [props.description, props.image, location.pathname, i18n]);
    return (
        <>
            <Helmet>
                <title>{`${t(props.description)}  | Mercedes-Benz Trucks Operating Fluids`}</title>
                <meta name="description"
                      content={props.metaDescription || `Find the best ${t(props.description)} oil.`}/>
                <meta name="keywords" content={props.keywords || ''}/>
                <meta name="robots" content="index, follow"/>
                <link rel="canonical" href={`https://bevo.mercedes-benz-trucks.com${location.pathname}`}/>

                <html lang={i18n.language}/>
                <link rel="alternate" href="https://bevo.mercedes-benz-trucks.com/en/" hrefLang="en"/>
                <link rel="alternate" href="https://bevo.mercedes-benz-trucks.com/de/" hrefLang="de"/>
                <link rel="alternate" href="https://bevo.mercedes-benz-trucks.com/pt/" hrefLang="pt"/>

                <meta property="og:title" content={`${t(props.description)} | Mercedes-Benz Trucks Operating Fluids`}/>
                <meta property="og:description"
                      content={props.metaDescription || `Find the best ${t(props.description)} oil.`}/>
                <meta property="og:type" content="website"/>
                <meta property="og:url" content={`https://bevo.mercedes-benz-trucks.com${location.pathname}`}/>
                <meta property="og:image" content={props.image}/>

                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title" content={`${t(props.description)} | Mercedes-Benz Trucks Operating Fluids`}/>
                <meta name="twitter:description"
                      content={props.metaDescription || 'Find the best oil for this category.'}/>
                <meta name="twitter:image" content={props.image}/>

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Product",
                        "name": t(props.description),
                        "description": props.metaDescription,
                        "image": props.image,
                        "url": `https://bevo.mercedes-benz-trucks.com${location.pathname}`
                    })}
                </script>
            </Helmet>
            <div>
                <HeaderBanner
                    image={props.image}
                    description={t(props.description)}
                ></HeaderBanner>
                <Prolog description={t(props.description)}></Prolog>

                {props.static && (
                    <div
                        style={{marginLeft: '14px', marginRight: '14px'}}
                    >
                        <p className='wb-type-copy-tertiary textWhite spaceTopLarge spaceBottom'
                           style={{whiteSpace: "pre-line"}}>
                            {t(props?.staticDetails?.toString())}
                        </p>
                    </div>
                )}

                <div style={{marginTop: '10px'}}>
                    {props.static ? (
                        <StaticCategoryTable description={props.description}/>
                    ) : (
                        <CategoryTable description={props.description}/>
                    )}
                </div>
                <div
                    style={{marginTop: '80px', marginRight: '14px', marginLeft: '14px'}}
                >
                    <CategoryList description={props.description}></CategoryList>
                </div>
            </div>
        </>
    );
};
